import * as React from 'react';

import { Typography2 } from '@coursera/cds-core';

import _t from 'i18n!nls/directory-graphql';

export default function () {
  return (
    <Typography2 component="p" variant="bodyPrimary">
      {_t('Page not found.')}
    </Typography2>
  );
}
